export enum OnboardingState {
  WaitingForClient,
  WaitingForAdminApproval
}